import { ConditionalRule } from '../validations/validations';

export function evaluateCondition(
  conditional: ConditionalRule,
  parentValue: any,
): boolean {
  const resolvedValue =
    parentValue && typeof parentValue === 'object' && 'value' in parentValue
      ? parentValue.value
      : parentValue;

  switch (conditional.operator) {
    case 'equals':
      return resolvedValue === conditional.value;
    case 'notEquals':
      return resolvedValue !== conditional.value;
    case 'contains':
      return (
        typeof resolvedValue === 'string' &&
        resolvedValue.includes(conditional.value)
      );
    case 'in':
      return (
        Array.isArray(conditional.value) &&
        conditional.value.includes(resolvedValue)
      );
    case 'notEmpty':
      return (
        resolvedValue !== null &&
        resolvedValue !== undefined &&
        resolvedValue !== ''
      );
    default:
      return true;
  }
}
